import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { ProdutoAtualizacaoDemandaElement, ProdutoConsultaElement } from '../../interfaces/produtos.consulta';
import { ProdutoAlteradoElement } from '../../interfaces/produto.alterado';
import { MatStepper } from '@angular/material/stepper';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { NovoGrupoDialog } from '../dialogs/novo-grupo-dialog/novo-grupo-dialog';
import { NovoUnidadeMedidaDialog } from '../dialogs/novo-unidade-medida-dialog/novo-unidade-medida-dialog';
import { NovoFornecedorDialog } from '../dialogs/novo-fornecedor-dialog/novo-fornecedor-dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AngularFireStorage } from "@angular/fire/storage";

import { take } from 'rxjs/operators';
import { UploadImagemDialogDialog } from '../dialogs/upload-imagem-dialog/upload-imagem-dialog';
import { ProdutoEstoqueConsulta, ProdutoEstoqueElement } from 'src/app/interfaces/produtos.estoque';
import { ExcelService } from 'src/app/services/excel.service';
import funcoesGerais from 'src/app/funcoes/funcoesGerais';

import * as XLSX from 'xlsx';

@Component({
  selector: 'app-consultar-produto',
  templateUrl: './consultar-produto.component.html',
  styleUrls: ['./consultar-produto.component.scss', '../../styles/estilo.padrao.scss']
})
export class ConsultarProdutoComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;

  uid;
  file;
  idProdutoCadastrado;
  produtoForm: FormGroup;
  consultaForm: FormGroup;
  bConsulta: boolean = false;
  bImagemAlterada: boolean = false;
  bTabela: boolean = false;
  bCodigoBarras: boolean = true;
  bCaracterEspecial: boolean = false;
  atualizarExcel: boolean = false;
  filtroTabela = "";
  estoques: ProdutoEstoqueElement[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  excelService: ExcelService = new ExcelService();

  // produtosSource: Array<ProdutoConsultaElement>;
  produtosSource;

  displayedColumns: string[] = ['Codigo', 'Nome', 'Grupo', 'Valor', 'QntEstoque', 'Consultar'];
  produtos = [];
  auxObservableNomesProdutos;
  auxObservableCodigoProdutos;

  grupos: any[] = [];
  fornecedores: any[] = [];
  unidadesMedidas: any[] = [];

  tipoItem: any[] = [
    { value: 'Venda', name: 'Venda' },
    { value: 'Consumo', name: 'Consumo' },
    { value: 'Imobilizado', name: 'Imobilizado' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private storage: AngularFireStorage

  ) {
    this.uid = localStorage.getItem('uid');

    //Pegar o produto recém cadastrado
    this.activatedRoute.queryParams.subscribe(value => {
      const dado = value;
      if (dado.IDProduto) {
        this.idProdutoCadastrado = dado.IDProduto;
      }
    });
  }

  ngOnInit(): void {
    this.consultaForm = this.formBuilder.group({
      nomeProduto: ['', null],
      contendo: ['', null],
      codBarras: ['', null],
      grupo: ['Todos', null],
      tipoBusca: [true, null],
    });

    this.produtoForm = this.formBuilder.group({
      idProduto: ['', null],
      status: [false, null],
      img64: [false, null],
      urlImagem: ['', null],
      dataHoraCadastro: ['', null],
      timestampCadastro: ['', null],
      //Parte 1
      tipoItem: ['', [Validators.required]],
      unidade: ['', [Validators.required]],
      idUnidade: ['', null],
      nomeProduto: ['', [Validators.required]],
      grupo: ['', [Validators.required]],
      idGrupo: ['', null],
      fornecedorPreferencial: ['', null],
      codigoBarras: ['', null],
      descricaoComplementar: ['', Validators.required],
      referencia: ['', null],
      //Parte 2
      valor: [0, [Validators.required]],
      valorCopia: [0, null], //Nunca 0
      valorAtacado: [0, [Validators.required]],
      quantidadeAtacado: ['', null],
      quantidadeEstoque: [0, [Validators.required, Validators.min(0)]],
      quantidadeMinimaAlertaEstoque: [1, [Validators.required, Validators.min(1)]], // irá gerar um alerta quando a quantidade em estoque estiver abaixo deste parâmetro
      quantidadeMinima: ['', null],
      quantidadeMaxima: [1, [Validators.required, Validators.min(1)]],
      identificador: ['', null],
      codigo: ['', [Validators.required]],
      lucroBruto: ['', null],
      comissao: ['', null],
      custoCompra: ['', null],
      custoMedio: ['', null],
      //Parte 5
      valorPromocional: [0, [Validators.required]],
      periodoPromocionalInicial: [new Date(), [Validators.required]],
      periodoPromocionalFinal: [new Date(), [Validators.required]],
    });

    this.produtoForm.get('codigo').disable();
    // this.produtoForm.get('tipoIPI').disable();
    this.produtoForm.get('custoMedio').disable();
    this.produtoForm.get('unidade').disable();
    // this.produtoForm.get('quantidadeEstoque').disable();
    this.produtoForm.get('valorCopia').disable();
    this.produtoForm.get('quantidadeEstoque').disable();

    this.getGrupos(null);
    this.getUnidadesMedidas();
    this.getFornecedores(null);
    this.buscarEstoques();

    this.idProdutoCadastrado ? this.buscarProdutoID() : null;
  }

  async buscarEstoques() {
    this.estoques = await this.usuarioService.getEstoquesProdutos();
  }

  novoFornecedor() {
    const dialogRef = this.dialog.open(NovoFornecedorDialog);
    dialogRef.afterClosed().subscribe(result => {

      result ? this.getFornecedores(result) : null;
    });
  }

  novoUnidadesMedida() {
    const dialogRef = this.dialog.open(NovoUnidadeMedidaDialog);
    dialogRef.afterClosed().subscribe(result => {

      // result ? this.getUnidadesMedidas(result) : null;
    });
  }

  novoProduto() {
    const dialogRef = this.dialog.open(NovoGrupoDialog);
    dialogRef.afterClosed().subscribe(result => {

      result ? this.getGrupos(result) : null;
    });
  }

  getFornecedores(idFornecedor) {
    //Recupera os fornecedores
    this.usuarioService.getFornecedores(this.uid).pipe(take(1)).subscribe(snap => {
      this.fornecedores = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (dados.Status) {
            this.fornecedores.push({
              value: item.key,
              name: dados.NomeFantasia
            });
          }
        });

        //Ordena alfabeticamente
        this.fornecedores.sort((a, b) => a.name.localeCompare(b.name));

        if (idFornecedor) {
          this.produtoForm.get('fornecedorPreferencial').patchValue(this.fornecedores[this.fornecedores.findIndex(x => x.value === idFornecedor)].value);
        }
      }
    });

    //Recupera o código para um novo produto
    this.usuarioService.getContCodigoProdutos(this.uid).subscribe(snap => {
      this.produtoForm.get('codigo').patchValue(Number(snap) + 1);

      setTimeout(() => this.spinner.hide('novo-produto'), 1000);
    });
  }

  getUnidadesMedidas() {
    //Recupera unidades de medidas cadastradas
    this.usuarioService.getUnidadesMedidas(this.uid).pipe(take(1)).subscribe(snap => {
      this.unidadesMedidas = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          this.unidadesMedidas.push({
            value: dados.Nome,
            name: dados.Nome,
            idUnidade: item.key
          });
        });

        //Ordena alfabeticamente
        this.unidadesMedidas.sort((a, b) => a.value.localeCompare(b.value));

        //Não pode alterar a unidade de medida na consulta
        // if (idUnidade) {
        //   this.produtoForm.get('unidade').patchValue(this.unidadesMedidas[this.unidadesMedidas.findIndex(x => x.idUnidade === idUnidade)].value);
        // }
      }
    });
  }

  getGrupos(idGrupo) {
    //Recupera grupos cadastrados
    this.usuarioService.getGrupos(this.uid).pipe(take(1)).subscribe(snap => {
      this.grupos = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          this.grupos.push({
            value: dados.Nome,
            name: dados.Nome,
            idGrupo: item.key
          });
        });

        //Ordena alfabeticamente
        this.grupos.sort((a, b) => a.value.localeCompare(b.value));

        this.grupos.unshift({
          value: 'Todos',
          name: 'Todos',
          idGrupo: 'Todos'
        });


        if (idGrupo) {
          this.produtoForm.get('grupo').patchValue(this.grupos[this.grupos.findIndex(x => x.idGrupo === idGrupo)].value);
        }
      }
    });
  }

  buscarProdutoID() {
    this.usuarioService.getProdutoID(this.idProdutoCadastrado, this.uid).pipe(take(1)).subscribe(snap => {
      if (snap) {
        const dados: any = snap.payload.val();
        this.detalharProduto({
          ID: snap.key,
          Status: dados.Status,
          URL_Imagem: dados.URL_Imagem,
          DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
          //Parte 1
          TipoItem: dados.TipoItem,
          Unidade: dados.Unidade,
          IDUnidade: dados.IDUnidade,
          Nome: dados.Nome,
          NomeBusca: dados.NomeBusca,
          Grupo: dados.Grupo,
          IDGrupo: dados.IDGrupo,
          IDFornecedorPreferencial: dados.IDFornecedorPreferencial,
          CodigoBarras: dados.CodigoBarras,
          DescricaoComplementar: dados.DescricaoComplementar,
          Referencia: dados.Referencia,
          //Parte 2
          Valor: dados.Valor,
          ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
          ValorAtacado: dados.ValorAtacado,
          QuantidadeAtacado: dados.QuantidadeAtacado,
          QuantidadeEstoque: dados.QuantidadeEstoque,
          QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque,
          QuantidadeMinima: dados.QuantidadeMinima,
          QuantidadeMaxima: dados.QuantidadeMaxima,
          Identificador: dados.Identificador,
          CodigoProduto: dados.CodigoProduto, // Fazer em função em nuvem ou cadastro posterior
          LucroBruto: dados.LucroBruto,
          Comissao: dados.Comissao,
          CustoCompra: dados.CustoCompra,
          CustoMedio: dados.CustoMedio,
          //Parte 5
          ValorPromocional: dados.ValorPromocional,
          TimestampInicialPromocional: dados.TimestampInicialPromocional,
          TimestampFinalPromocional: dados.TimestampFinalPromocional,
          //Demais parâmetros
          TimestampCadastro: dados.TimestampCadastro
        });
      }
    })
  }

  async consultarTodosProdutos() {
    this.spinner.show('consultar-produto');

    this.usuarioService.getProdutos().subscribe(snap => {
      // let auxProdutosSource: ProdutoConsultaElement[] = [];
      // this.produtosSource = [];

      if (snap.length > 0) {
        var dados;
        let auxProdutosSource: ProdutoConsultaElement[] = [];

        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (!this.g.tipoBusca.value) {
            if (dados.NomeBusca.includes(this.g.contendo.value.toLowerCase())) {
              auxProdutosSource.push({
                ID: item.key,
                Status: dados.Status,
                URL_Imagem: dados.URL_Imagem,
                DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
                //Parte 1
                TipoItem: dados.TipoItem,
                Unidade: dados.Unidade,
                IDUnidade: dados.IDUnidade,
                Nome: dados.Nome,
                NomeBusca: dados.NomeBusca,
                Grupo: dados.Grupo,
                IDGrupo: dados.IDGrupo,
                IDFornecedorPreferencial: dados.IDFornecedorPreferencial,
                CodigoBarras: dados.CodigoBarras,
                DescricaoComplementar: dados.DescricaoComplementar,
                Referencia: dados.Referencia,
                //Parte 2
                Valor: dados.Valor,
                ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
                ValorAtacado: dados.ValorAtacado,
                QuantidadeAtacado: dados.QuantidadeAtacado,
                //@ts-ignore
                QuantidadeEstoque: this.estoques.find(x => x.ID === item.key)?.QuantidadeEstoque || '-',
                QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque,
                QuantidadeMinima: dados.QuantidadeMinima,
                QuantidadeMaxima: dados.QuantidadeMaxima,
                Identificador: dados.Identificador,
                CodigoProduto: dados.CodigoProduto, // Fazer em função em nuvem ou cadastro posterior
                LucroBruto: dados.LucroBruto,
                Comissao: dados.Comissao,
                CustoCompra: dados.CustoCompra,
                CustoMedio: dados.CustoMedio,
                //Parte 5
                ValorPromocional: dados.ValorPromocional,
                TimestampInicialPromocional: dados.TimestampInicialPromocional,
                TimestampFinalPromocional: dados.TimestampFinalPromocional,
                //Demais parâmetros
                TimestampCadastro: dados.TimestampCadastro
              });
            }
          } else {
            if (this.g.tipoBusca.value && (this.g.grupo.value === 'Todos' || this.g.grupo.value === dados.IDGrupo)) {
              auxProdutosSource.push({
                ID: item.key,
                Status: dados.Status,
                URL_Imagem: dados.URL_Imagem,
                DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
                //Parte 1
                TipoItem: dados.TipoItem,
                Unidade: dados.Unidade,
                IDUnidade: dados.IDUnidade,
                Nome: dados.Nome,
                NomeBusca: dados.NomeBusca,
                Grupo: dados.Grupo,
                IDGrupo: dados.IDGrupo,
                IDFornecedorPreferencial: dados.IDFornecedorPreferencial,
                CodigoBarras: dados.CodigoBarras,
                DescricaoComplementar: dados.DescricaoComplementar,
                Referencia: dados.Referencia,
                //Parte 2
                Valor: dados.Valor,
                ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
                ValorAtacado: dados.ValorAtacado,
                QuantidadeAtacado: dados.QuantidadeAtacado,
                //@ts-ignore
                QuantidadeEstoque: this.estoques.find(x => x.ID === item.key)?.QuantidadeEstoque || '-',
                QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque,
                QuantidadeMinima: dados.QuantidadeMinima,
                QuantidadeMaxima: dados.QuantidadeMaxima,
                Identificador: dados.Identificador,
                CodigoProduto: dados.CodigoProduto, // Fazer em função em nuvem ou cadastro posterior
                LucroBruto: dados.LucroBruto,
                Comissao: dados.Comissao,
                CustoCompra: dados.CustoCompra,
                CustoMedio: dados.CustoMedio,
                //Parte 5
                ValorPromocional: dados.ValorPromocional,
                TimestampInicialPromocional: dados.TimestampInicialPromocional,
                TimestampFinalPromocional: dados.TimestampFinalPromocional,
                //Demais parâmetros
                TimestampCadastro: dados.TimestampCadastro
              });
            }
          }
        });

        //Ordena alfabeticamente
        // this.produtosSource.sort((a, b) => a.Nome.localeCompare(b.Nome));
        //Ordena pelo código
        // auxProdutosSource.sort((a, b) => a.CodigoProduto - b.CodigoProduto);
        auxProdutosSource.sort((a, b) => a.Nome.localeCompare(b.Nome));

        this.produtosSource = new MatTableDataSource(auxProdutosSource);
        setTimeout(() => this.produtosSource.paginator = this.paginator, 50);

        this.bTabela = true;
        setTimeout(() => this.spinner.hide('consultar-produto'), 300);
      } else {
        this.bTabela = false;
        this.toastr.error("Não foi possível localizar produtos!", 'Erro');
        setTimeout(() => this.spinner.hide('consultar-produto'), 300);
      }
    });
  }

  onChangeNomeProduto(e) {
    if (e.length >= 4) {
      this.auxObservableNomesProdutos = this.usuarioService.getBuscaInicioNomeProduto(this.uid, e.toLowerCase()).subscribe(snap => {
        var dados;
        this.produtos = [];

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.NomeBusca.includes(e.toLowerCase())) {
            this.produtos.push({
              ID: item.key,
              Status: dados.Status,
              URL_Imagem: dados.URL_Imagem,
              DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
              //Parte 1
              TipoItem: dados.TipoItem,
              Unidade: dados.Unidade,
              IDUnidade: dados.IDUnidade,
              Nome: dados.Nome,
              NomeBusca: dados.NomeBusca,
              Grupo: dados.Grupo,
              IDGrupo: dados.IDGrupo,
              IDFornecedorPreferencial: dados.IDFornecedorPreferencial,
              CodigoBarras: dados.CodigoBarras,
              DescricaoComplementar: dados.DescricaoComplementar,
              Referencia: dados.Referencia,
              //Parte 2
              Valor: dados.Valor,
              ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
              ValorAtacado: dados.ValorAtacado,
              QuantidadeAtacado: dados.QuantidadeAtacado,
              QuantidadeEstoque: this.estoques.find(x => x.ID === item.key)?.QuantidadeEstoque || '-',
              QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque,
              QuantidadeMinima: dados.QuantidadeMinima,
              QuantidadeMaxima: dados.QuantidadeMaxima,
              Identificador: dados.Identificador,
              CodigoProduto: dados.CodigoProduto, // Fazer em função em nuvem ou cadastro posterior
              LucroBruto: dados.LucroBruto,
              Comissao: dados.Comissao,
              CustoCompra: dados.CustoCompra,
              CustoMedio: dados.CustoMedio,
              //Parte 5
              ValorPromocional: dados.ValorPromocional,
              TimestampInicialPromocional: dados.TimestampInicialPromocional,
              TimestampFinalPromocional: dados.TimestampFinalPromocional,
              //Demais parâmetros
              TimestampCadastro: dados.TimestampCadastro
            });
          }
        });
      });
    }
  }


  onChangeCodigoBarras(e) {
    if (e.length >= 2) {
      this.auxObservableCodigoProdutos = this.usuarioService.getBuscaCodigoBarras(this.uid, e).subscribe(snap => {
        var dados;
        this.produtos = [];

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.CodigoBarras.includes(e)) {
            this.produtos.push({
              ID: item.key,
              Status: dados.Status,
              URL_Imagem: dados.URL_Imagem,
              DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
              //Parte 1
              TipoItem: dados.TipoItem,
              Unidade: dados.Unidade,
              IDUnidade: dados.IDUnidade,
              Nome: dados.Nome,
              NomeBusca: dados.NomeBusca,
              Grupo: dados.Grupo,
              IDGrupo: dados.IDGrupo,
              IDFornecedorPreferencial: dados.IDFornecedorPreferencial,
              CodigoBarras: dados.CodigoBarras,
              DescricaoComplementar: dados.DescricaoComplementar,
              Referencia: dados.Referencia,
              //Parte 2
              Valor: dados.Valor,
              ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
              ValorAtacado: dados.ValorAtacado,
              QuantidadeAtacado: dados.QuantidadeAtacado,
              QuantidadeEstoque: this.estoques.find(x => x.ID === item.key)?.QuantidadeEstoque || '-',
              QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque,
              QuantidadeMinima: dados.QuantidadeMinima,
              QuantidadeMaxima: dados.QuantidadeMaxima,
              Identificador: dados.Identificador,
              CodigoProduto: dados.CodigoProduto, // Fazer em função em nuvem ou cadastro posterior
              LucroBruto: dados.LucroBruto,
              Comissao: dados.Comissao,
              CustoCompra: dados.CustoCompra,
              CustoMedio: dados.CustoMedio,
              //Parte 5
              ValorPromocional: dados.ValorPromocional,
              TimestampInicialPromocional: dados.TimestampInicialPromocional,
              TimestampFinalPromocional: dados.TimestampFinalPromocional,
              //Demais parâmetros
              TimestampCadastro: dados.TimestampCadastro
            });
          }
        });
      });
    }
  }

  paginas(b, pagina) {
    if (b) {
      let bAux = true;

      switch (pagina) {
        case 1:
          this.f.tipoItem.errors ? (this.produtoForm.get('tipoItem').markAsTouched(), bAux = false) : null;
          this.f.nomeProduto.errors ? (this.produtoForm.get('nomeProduto').markAsTouched(), bAux = false) : null;
          this.f.descricaoComplementar.errors ? (this.produtoForm.get('descricaoComplementar').markAsTouched(), bAux = false) : null;
          this.f.unidade.errors ? (this.produtoForm.get('unidade').markAsTouched(), bAux = false) : null;
          this.f.grupo.errors ? (this.produtoForm.get('grupo').markAsTouched(), bAux = false) : null;

          bAux ? this.stepper.next() : null;
          break;

        case 2:
          this.f.valor.errors ? (this.produtoForm.get('valor').markAsTouched(), bAux = false) : null;
          this.f.quantidadeMaxima.errors ? (this.produtoForm.get('quantidadeMaxima').markAsTouched(), bAux = false) : null;

          if (this.f.valorAtacado.value !== 0) {
            this.produtoForm.get('quantidadeAtacado').setValidators([Validators.required, Validators.min(1)]);
            this.produtoForm.get('quantidadeAtacado').updateValueAndValidity()
            this.f.quantidadeAtacado.errors ? (this.produtoForm.get('quantidadeAtacado').markAsTouched(), bAux = false) : null;

            this.f.valorAtacado.errors ? (this.produtoForm.get('valorAtacado').markAsTouched(), bAux = false) : null;
          } else {
            this.produtoForm.get('quantidadeAtacado').clearValidators();
            this.produtoForm.get('quantidadeAtacado').updateValueAndValidity()
          }

          bAux ? this.stepper.next() : null;
          break;

        case 3:

          this.f.cstNFe.errors ? (this.produtoForm.get('cstNFe').markAsTouched(), bAux = false) : null;
          this.f.csosnNFe.errors ? (this.produtoForm.get('csosnNFe').markAsTouched(), bAux = false) : null;
          this.f.cstCFe.errors ? (this.produtoForm.get('cstCFe').markAsTouched(), bAux = false) : null;
          this.f.csosnCFe.errors ? (this.produtoForm.get('csosnCFe').markAsTouched(), bAux = false) : null;
          this.f.taxaICMSISS.errors ? (this.produtoForm.get('taxaICMSISS').markAsTouched(), bAux = false) : null;
          this.f.taxaICMSISSCFe.errors ? (this.produtoForm.get('taxaICMSISSCFe').markAsTouched(), bAux = false) : null;
          this.f.cfopECF.errors ? (this.produtoForm.get('cfopECF').markAsTouched(), bAux = false) : null;
          this.f.cfopNF.errors ? (this.produtoForm.get('cfopNF').markAsTouched(), bAux = false) : null;
          this.f.ncm.errors ? (this.produtoForm.get('ncm').markAsTouched(), bAux = false) : null;

          if (this.f.cstNFe.value === '060' || this.f.cstNFe.value === '070' || this.f.cstNFe.value === '010' || this.f.cstNFe.value === '090') {
            this.produtoForm.get('cest').setValidators([Validators.required]);
            this.produtoForm.get('cest').updateValueAndValidity()
            this.f.cest.errors ? (this.produtoForm.get('cest').markAsTouched(), bAux = false) : null;
          } else {
            this.produtoForm.get('cest').clearValidators();
            this.produtoForm.get('cest').updateValueAndValidity()
          }

          bAux ? this.stepper.next() : null;
          break;

        case 4:
          bAux ? this.stepper.next() : null;
          break;
      }

    } else {
      pagina === 1 ? this.produtoForm.get('valor').enable() : null;
      this.stepper.previous();
    }
  }

  validaCodigoBarras() {
    this.usuarioService.getProdutoCodBarras(this.uid, this.f.codBarras.value).subscribe(snap => {
      this.bCodigoBarras = snap.length > 0 ? false : true;
      setTimeout(() => {
        this.f.codBarras.updateValueAndValidity()
      }, 100);
    });
  }

  async getBase64FromUrl(url) {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }


  async detalharProduto(dados) {
    this.spinner.show('consultar-produto');

    if (dados) {

      if (dados.URL_Imagem) {
        this.produtoForm.get('img64').patchValue(await this.getBase64FromUrl(dados.URL_Imagem));
      } else {
        this.produtoForm.get('img64').patchValue(null);
      }

      this.produtoForm.get('idProduto').patchValue(dados.ID);
      this.produtoForm.get('status').patchValue(dados.Status);
      this.produtoForm.get('urlImagem').patchValue(dados.URL_Imagem);
      this.produtoForm.get('dataHoraCadastro').patchValue(dados.DataHoraCadastro);
      this.produtoForm.get('timestampCadastro').patchValue(dados.TimestampCadastro);
      this.produtoForm.get('tipoItem').patchValue(dados.TipoItem);
      this.produtoForm.get('unidade').patchValue(dados.Unidade);
      this.produtoForm.get('idUnidade').patchValue(dados.IDUnidade);
      this.produtoForm.get('nomeProduto').patchValue(dados.Nome);
      this.produtoForm.get('grupo').patchValue(dados.Grupo);
      this.produtoForm.get('idGrupo').patchValue(dados.IDGrupo);
      this.produtoForm.get('fornecedorPreferencial').patchValue(dados.IDFornecedorPreferencial);
      this.produtoForm.get('codigoBarras').patchValue(dados.CodigoBarras);
      this.produtoForm.get('descricaoComplementar').patchValue(dados.DescricaoComplementar);
      this.produtoForm.get('referencia').patchValue(dados.Referencia);
      this.produtoForm.get('valor').patchValue(dados.Valor);
      this.produtoForm.get('valorCopia').patchValue(dados.Valor);
      this.produtoForm.get('valorAtacado').patchValue(dados.ValorAtacado);
      this.produtoForm.get('quantidadeAtacado').patchValue(dados.QuantidadeAtacado);
      this.produtoForm.get('quantidadeEstoque').patchValue('-');
      this.produtoForm.get('quantidadeMinimaAlertaEstoque').patchValue(dados.QuantidadeMinimaAlertaEstoque);
      this.produtoForm.get('quantidadeMinima').patchValue(dados.QuantidadeMinima);
      this.produtoForm.get('quantidadeMaxima').patchValue(dados.QuantidadeMaxima);
      this.produtoForm.get('identificador').patchValue(dados.Identificador);
      this.produtoForm.get('codigo').patchValue(dados.CodigoProduto);
      this.produtoForm.get('lucroBruto').patchValue(dados.LucroBruto);
      this.produtoForm.get('comissao').patchValue(dados.Comissao);
      this.produtoForm.get('custoCompra').patchValue(dados.CustoCompra);
      this.produtoForm.get('custoMedio').patchValue(dados.CustoMedio);
      this.produtoForm.get('valorPromocional').patchValue(dados.ValorPromocional);
      this.produtoForm.get('periodoPromocionalInicial').patchValue(new Date(dados.TimestampInicialPromocional));
      this.produtoForm.get('periodoPromocionalFinal').patchValue(new Date(dados.TimestampFinalPromocional));

      this.usuarioService.getEstoqueProduto(dados.ID).pipe(take(1)).subscribe(snap => {
        this.produtoForm.get('quantidadeEstoque').patchValue(snap ? snap : '0');
      });

      this.bCaracterEspecial = false;

      setTimeout(() => this.bConsulta = true, 150);

    }
    setTimeout(() => this.spinner.hide('consultar-produto'), 400);
  }

  salvar() {
    this.spinner.show('default');

    //Tratamento de obrigatoriedade feito a mão
    if (this.validarCampos()) {
      if (this.bCodigoBarras) {

        if (this.bImagemAlterada && this.f.img64.value) {
          try {

            const img = this.bitToPNG();

            var n = Date.now();
            const filePath = `IpanemaImagens/${n}`;
            const fileRef = this.storage.ref(filePath);
            const task = this.storage.upload(`IpanemaImagens/${n}`, img).then(url => {
              let downloadURL = fileRef.getDownloadURL();
              downloadURL.subscribe(url => {
                if (url) {
                  this.produtoForm.get('urlImagem').patchValue(url);
                  this.finalizarAlteracaoProduto();
                }
              });
            });
          } catch (e) {
            console.log(e)
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro ao realizar o upload da foto do produto!", e, this.uid);
            this.toastr.error('Erro ao realizar o upload da foto do produto!!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/novo-produto"]));
          }
        } else {
          this.finalizarAlteracaoProduto();
        }

      } else {
        this.toastr.error('Este código de barras já consta no sistema!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
        this.produtoForm.get('codBarras').markAsTouched();
        setTimeout(() => this.spinner.hide('default'), 500);
      }
    } else {
      this.toastr.warning('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  finalizarAlteracaoProduto() {

    let map: ProdutoAlteradoElement = {
      //Parte 1
      Status: this.f.status.value,
      URL_Imagem: this.f.img64.value && this.f.urlImagem.value.length > 0 ? this.f.urlImagem.value : false,
      TipoItem: this.f.tipoItem.value,
      Unidade: this.f.unidade.value,
      IDUnidade: this.unidadesMedidas[this.unidadesMedidas.findIndex(x => x.value === this.f.unidade.value)].idUnidade,
      Nome: this.f.nomeProduto.value.trim(),
      NomeBusca: this.f.nomeProduto.value.trim().toLowerCase(),
      Grupo: this.f.grupo.value,
      IDGrupo: this.grupos[this.grupos.findIndex(x => x.value === this.f.grupo.value)].idGrupo,
      IDFornecedorPreferencial: this.f.fornecedorPreferencial.value,
      CodigoBarras: this.f.codigoBarras.value.trim(),
      DescricaoComplementar: this.f.descricaoComplementar.value.trim(),
      Referencia: this.f.referencia.value.trim(),
      //Parte 2
      Valor: this.f.valor.value,
      ValorAtacado: this.f.valorAtacado.value,
      QuantidadeAtacado: this.f.quantidadeAtacado.value,
      // QuantidadeEstoque: this.f.quantidadeEstoque.value, //Esse dado não pode ser alterado por aqui
      QuantidadeMinimaAlertaEstoque: 1, //this.f.quantidadeMinimaAlertaEstoque.value  QUANDO LANÇAR
      QuantidadeMinima: this.f.quantidadeMinima.value,
      QuantidadeMaxima: this.f.quantidadeMaxima.value,
      Identificador: this.f.identificador.value,
      CodigoProduto: this.f.codigo.value, // Fazer em função em nuvem ou cadastro posterior
      LucroBruto: this.f.lucroBruto.value !== '' ? this.f.lucroBruto.value / 100 : 0,
      Comissao: this.f.comissao.value !== '' ? this.f.comissao.value / 100 : 0,
      CustoCompra: this.f.custoCompra.value !== '' ? this.f.custoCompra.value : 0,
      CustoMedio: this.f.custoMedio.value,
      //Parte 5
      ValorPromocional: this.f.valorPromocional.value,
      TimestampInicialPromocional: new Date(this.f.periodoPromocionalInicial.value).getTime(),
      TimestampFinalPromocional: new Date(this.f.periodoPromocionalFinal.value).getTime(),
    }

    try {
      const resp = this.usuarioService.updateProduto(map, this.f.idProduto.value);
      setTimeout(() => {
        this.spinner.hide('default');
        this.usuarioService.setLog("Alteração de produto. ID: " + this.f.idProduto.value + ' Nome: ' + this.f.nomeProduto.value, map, this.uid);

        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/consultar-produto"]));
      }, 1500);
    } catch (e) {
      console.log(e)
      this.spinner.hide('default');
      this.usuarioService.setLog("Erro ao atualizar produto!", e, this.uid);
      this.toastr.error('Erro ao atualizar produto!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
      this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
        this.router.navigate(["/pages/consultar-produto"]));
    }
  }

  deletarFoto() {
    this.produtoForm.get('img64').patchValue(false);
  }

  uploadFoto() {
    const dialogRef = this.dialog.open(UploadImagemDialogDialog, {
      data: {
        img64: this.f.img64.value ? this.bitToPNG() : false,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bImagemAlterada = true;
        this.produtoForm.get('img64').patchValue(result);
      }
    });
  }

  bitToPNG() {
    /* Retorna a base 64 para PNG */
    var binary = atob(this.f.img64.value.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: 'image/png'
    });
    /* Fim */
  }

  // onFileSelected(event) {
  //   this.file = event.target.files[0];
  // }

  alteracaoValor(b) {
    this.produtoForm.get('valorCopia').patchValue(this.f.valor.value);
    if (b) {
      this.produtoForm.get('valorAtacado').setValidators([Validators.max(this.f.valor.value)]);
      this.produtoForm.get('valorAtacado').updateValueAndValidity();
    } else {
      this.produtoForm.get('valorAtacado').markAsTouched();
    }
  }

  alteracaoValorPromocional() {
    this.produtoForm.get('valorPromocional').setValidators([Validators.max(this.f.valor.value)]);
    this.produtoForm.get('valorPromocional').updateValueAndValidity();
    this.produtoForm.get('valorPromocional').markAsTouched();
  }

  //Trata cada campo, para ir para a página automaticamente...
  validarCampos() {
    let bAux = true;


    //Pagina 1 / 0
    this.f.tipoItem.errors ? (this.produtoForm.get('tipoItem').markAsTouched(), bAux = false) : null;
    this.f.nomeProduto.errors ? (this.produtoForm.get('nomeProduto').markAsTouched(), bAux = false) : null;
    this.f.unidade.errors ? (this.produtoForm.get('unidade').markAsTouched(), bAux = false) : null;
    this.f.grupo.errors ? (this.produtoForm.get('grupo').markAsTouched(), bAux = false) : null;

    if (!bAux) {
      this.stepper.selectedIndex = 0;
      return bAux;
    }

    //Pagina 2 / 1
    this.f.valor.errors ? (this.produtoForm.get('valor').markAsTouched(), bAux = false) : null;
    this.f.quantidadeMaxima.errors ? (this.produtoForm.get('quantidadeMaxima').markAsTouched(), bAux = false) : null;

    if (this.f.valorAtacado.value !== 0) {
      this.produtoForm.get('quantidadeAtacado').setValidators([Validators.required, Validators.min(1)]);
      this.produtoForm.get('quantidadeAtacado').updateValueAndValidity()
      this.f.quantidadeAtacado.errors ? (this.produtoForm.get('quantidadeAtacado').markAsTouched(), bAux = false) : null;
      this.f.valorAtacado.errors ? (this.produtoForm.get('valorAtacado').markAsTouched(), bAux = false) : null;
    } else {
      this.produtoForm.get('quantidadeAtacado').clearValidators();
      this.produtoForm.get('quantidadeAtacado').updateValueAndValidity()
    }

    if (!bAux) {
      this.stepper.selectedIndex = 1;
      return bAux;
    }

    if (!bAux) {
      this.stepper.selectedIndex = 2;
      return bAux;
    }

    this.f.valorPromocional.errors ? (this.produtoForm.get('valorPromocional').markAsTouched(), bAux = false) : null;
    if (!bAux) {
      this.stepper.selectedIndex = 4;
      return bAux;
    }

    return bAux;
  }

  voltar() {
    this.router.navigate([]);
    this.bConsulta = false;
  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/consultar-produto"]));
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.produtosSource.filter = filterValue.trim().toLowerCase();

    if (this.produtosSource.paginator) {
      this.produtosSource.paginator.firstPage();
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;

    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44 || k == 47) {
      return true;
    } else {
      this.bCaracterEspecial = true;
      return false;
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.produtoForm.controls; }

  get g() { return this.consultaForm.controls; }

  //#region Atualizar via excel
  atualizarPrecosExcel() {
    this.atualizarExcel = !this.atualizarExcel;
  }

  baixarPlanilhaModelo() {
    console.log('baixarPlanilhaModelo')
    this.usuarioService.getProdutos().pipe(take(1)).subscribe(snap => {
      let produtos: ProdutoAtualizacaoDemandaElement[] = [];

      if (snap.length > 0) {
        let dados: ProdutoAtualizacaoDemandaElement;

        snap.forEach((item) => {
          dados = item.payload.val() as ProdutoAtualizacaoDemandaElement;

          produtos.push({
            ID: item.key,
            Status: dados.Status ? 'Ativo' : 'Desativado',
            Unidade: dados.Unidade,
            Nome: dados.Nome,
            CustoCompra: dados.CustoCompra,
            Valor: dados.Valor,
          });
        });
      }

      this.excelService.exportAsExcelFile(produtos, `Modelo_importacao_produtos_${funcoesGerais.tratarData(new Date().getTime())}`);
    });
  }

  fileChangeEvent(event: any): void {
    try {
      this.spinner.show('default');

      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(event.target.files[0]);

      reader.onload = (e: any) => {
        /* create workbook */
        const binarystr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

        /* selected the first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        console.log('XLSX.utils.sheet_to_json(ws)', XLSX.utils.sheet_to_json(ws));
        setTimeout(() => this.atualizarValoresProdutos(XLSX.utils.sheet_to_json(ws)), 100);
        event.target.value = null;
      }
    } catch (error) {
      this.toastr.error(`Erro ao atualizar valores! Erro: ${JSON.stringify(error)}`, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('default'), 1000);
    }
  }

  async atualizarValoresProdutos(produtos: ProdutoAtualizacaoDemandaElement[]) {
    const erros: string[] = [];

    produtos.forEach(async produto => {
      await new Promise((resolve) => {
        if (!produto.ID)
          erros.push(`Erro ao atualizar produto ${produto.Nome}! Erro: ID não encontrado!`);

        if (isNaN(Number(produto.Valor))) {
          erros.push(`Erro ao atualizar produto ${produto.Nome}! Erro: Valor inválido!`);
        }
        if (isNaN(Number(produto.CustoCompra))) {
          erros.push(`Erro ao atualizar produto ${produto.Nome}! Erro: Custo compra inválido!`);
        }
        else
          if (Number(produto.Valor) < 0)
            erros.push(`Erro ao atualizar produto ${produto.Nome}! Erro: Valor não pode ser negativo!`);
          else
            this.usuarioService.updateProduto({ Valor: Number(produto.Valor), CustoCompra: Number(produto.CustoCompra) }, produto.ID).then(() => {
              resolve(true);
            }).catch((error) => {
              erros.push(`Erro ao atualizar produto ${produto.Nome}! Erro: ${error}`);
            });
      })
    });

    if (erros.length > 0) {
      alert(`Erros: ${erros.join('\n')}`);
    } else {
      this.toastr.success('Valores atualizados com sucesso!', 'Sucesso', { progressBar: true, positionClass: 'toast-top-center', });
    }

    setTimeout(() => this.spinner.hide('default'), 1000);
  }
  //#endregion

}